export default __webpack_public_path__ + "static/media/tie-mumbai.7ac33d36.jpg";